<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  stroke={color}
  stroke-width={strokeWidth}
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 48 48"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <path
    class="cls-1"
    d="M10.35,4.5a2,2,0,0,0-1.95,2v35.1a2,2,0,0,0,1.95,2h27.3a2,2,0,0,0,2-2V6.45a2,2,0,0,0-2-1.95h-2v8.82L31.79,9.41l-3.88,3.91V4.5Zm5.84,20H32.81M16.19,36.18H28.88M16.19,30.33h9.74"
  />
</svg>
